
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DropArea',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: 'Drop here...',
    },
    bordered: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['ondrop'],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    ondrop(e: DragEvent) {
      // console.log('DropArea ondrop', e);
      try {
        const data = e.dataTransfer?.getData('dnddata') ?? '';
        const dnddata = data ? JSON.parse(data) : e;

        // console.log('DropArea ondrop', dnddata);
        this.$emit('ondrop', dnddata);
      } catch (error) {
        console.error(`Error [${this.$options.name}]: `, error);
      }
    },
  },
});
